// extracted by mini-css-extract-plugin
export default {"zoomModal":"YZ-z"};